import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { ModalLock } from '../modal-lock'
import { PaywallLock } from '../paywall-lock'
import {
  AiTwoOffersLock_OfferLockDataFragment,
  AiTwoOffersLock_ViewerFragment,
} from './__generated__/ai-two-offers-lock.graphql'
import styles from './ai-two-offers-lock.module.scss'
import { AiTwoOffersLockContent } from './ai-two-offers-lock-content'

export interface AiTwoOffersLockProps {
  offerLockData: AiTwoOffersLock_OfferLockDataFragment
  viewer: AiTwoOffersLock_ViewerFragment
}

export function AiTwoOffersLock({ offerLockData, viewer }: AiTwoOffersLockProps) {
  const { componentType } = useContext(BoxLockContext)
  const content = <AiTwoOffersLockContent viewer={viewer} offerLockData={offerLockData} />

  switch (componentType) {
    case 'paywall':
      return (
        <PaywallLock offerLockData={offerLockData} className={styles['paywall-ai-two-offers-lock']}>
          {content}
        </PaywallLock>
      )
    case 'modal':
      return <ModalLock offerLockBody={offerLockData.body}>{content}</ModalLock>
    default:
      return null
  }
}

AiTwoOffersLock.fragments = {
  offerLockData: gql`
    fragment AiTwoOffersLock_offerLockData on OfferLockData {
      ...AiTwoOffersLockContent_offerLockData
      ...PaywallLock_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${PaywallLock.fragments.offerLockData}
    ${AiTwoOffersLockContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment AiTwoOffersLock_viewer on Profile {
      ...AiTwoOffersLockContent_viewer
    }
    ${AiTwoOffersLockContent.fragments.viewer}
  `,
}
